export default "__VITE_ASSET__CGIPu9FC__"